import type { IUrl } from "#/_packages/umbrella/features/form-block/types";
import type { CmsLinkModel } from "#/_packages/umbrella/integrations/umbraco/types/cms-link";

export function apiLinkToUrl(
	apiLink: CmsLinkModel | null | undefined,
): IUrl | undefined {
	if (!apiLink) return undefined;

	const url = apiLink.route?.path ?? apiLink.url;

	if (!url) return undefined;

	const link: IUrl = {
		url,
		name: apiLink.title ?? "Läs mer",
		target: apiLink.target ?? "_blank",
	};
	return link;
}
